import React, { Fragment } from "react";
import { TApiOrder } from "../../../api/endpoints/Order";
import OrderRow from "../OrderRow";
import LoadingIndicator from "../../Feedback/LoadingIndicator";
import { Nullable } from "../../../../types/utils";

interface IProps {
  loading: boolean;
  error: boolean;
  orders: Array<TApiOrder>;
  onOrderChange?: (order?: Nullable<TApiOrder>) => void;
}

const OrderListContent = (props: IProps) => {
  const { orders, loading, error, onOrderChange } = props;

  if (error) {
    return <tr>
      <td colSpan={100} className="empty-row-cell">Sorry! It seems data is currently unavailable.</td>
    </tr>;
  }

  if (loading) {
    return <tr>
      <td colSpan={100} className="empty-row-cell">
        <LoadingIndicator />
      </td>
    </tr>;
  }

  return (
    <Fragment>

      {
        orders.length ?
          orders.map(order => <OrderRow key={order.id} order={order} onOrderChange={onOrderChange} />)
          :
          <tr>
            <td colSpan={100} className="empty-row-cell">No orders found.</td>
          </tr>
      }
    </Fragment>
  )
}

export default OrderListContent;
